// @flow

import {Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CodeTooltip: MarkdocTagRegistration = {
  tag: 'code-tooltip',
  component: 'CodeTooltip',
  description: 'Display a code token tooltip',
  children: ['strong', 'em', 'text'],
  attributes: {
    content: {
      type: String,
      description: 'The tooltip content',
      required: true,
      localizable: true,
    },
  },
  render(node, config) {
    const {content} = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    return new Tag(this.tag, {content, value: children});
  },
};
